module.exports = __webpack_public_path__ + "img/error-seeroo.a1369856.png";